import React from 'react'

export default ({
  color,
  height = '16px',
  width = '14px',
}: {
  color?: string
  height?: string
  width?: string
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 16"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 2.5C5 3.71875 4.125 4.71875 3 4.96875V6C3 6.84375 3.65625 7.5 4.5 7.5H9.5C10.3125 7.5 11 6.84375 11 6V4.96875C9.84375 4.71875 9 3.71875 9 2.5C9 1.125 10.0938 0 11.5 0C12.875 0 14 1.125 14 2.5C14 3.71875 13.125 4.71875 12 4.96875V6C12 7.40625 10.875 8.5 9.5 8.5H7.5V11.0625C8.625 11.2812 9.5 12.3125 9.5 13.5C9.5 14.9062 8.375 16 7 16C5.59375 16 4.5 14.9062 4.5 13.5C4.5 12.3125 5.34375 11.2812 6.5 11.0625V8.5H4.5C3.09375 8.5 2 7.40625 2 6V4.96875C0.84375 4.71875 0 3.71875 0 2.5C0 1.125 1.09375 0 2.5 0C3.875 0 5 1.125 5 2.5ZM2.5 4C3.3125 4 4 3.34375 4 2.5C4 1.6875 3.3125 1 2.5 1C1.65625 1 1 1.6875 1 2.5C1 3.34375 1.65625 4 2.5 4ZM7 12C6.15625 12 5.5 12.6875 5.5 13.5C5.5 14.3438 6.15625 15 7 15C7.8125 15 8.5 14.3438 8.5 13.5C8.5 12.6875 7.8125 12 7 12ZM11.5 1C10.6562 1 10 1.6875 10 2.5C10 3.34375 10.6562 4 11.5 4C12.3125 4 13 3.34375 13 2.5C13 1.6875 12.3125 1 11.5 1Z"
      fill="#404861"
    />
  </svg>
)
